// extracted by mini-css-extract-plugin
module.exports = {"panel":"SelectedItemsList-module__panel__1d9PQ","deselect":"SelectedItemsList-module__deselect__1g89q"};